import React from 'react';
import TemplateParametro from '../shared/templateParametros/templateParametros';
import MultiplicadorPddIntermediariasService from '../../../../lib/api/multiplicadorPddIntermediarias/multiplicadorPddIntermediariasService';

class MultiplicadorPddIntermediarias extends React.Component<{},{}> 
{
    constructor(props: any) 
    {
        super(props);
        this.state = {};
    }

    baixarExcelParametrosPDDIntermediarias()
    {
        return MultiplicadorPddIntermediariasService.obterExcel()
    }
    
    enviarParametrosEventGrid() 
    {
        return MultiplicadorPddIntermediariasService.enviarParametrosAoEventGrid();
    }

    render() 
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelParametrosPDDIntermediarias}
                enviarExcelParametros={MultiplicadorPddIntermediariasService.enviarExcelParametros}
                deletarExcelParametros={MultiplicadorPddIntermediariasService.deletarExcelParametros}
                nomeDoArquivo='Parametro PDD Intermediarias'
            ></TemplateParametro>
        );
    }
}

export default MultiplicadorPddIntermediarias